<template>
  <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="1.28374"
      y="1.28374"
      width="25.0483"
      height="25.0483"
      rx="6.3412"
      stroke="currentColor"
      stroke-width="0.567486"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.1763 3.8999C6.71004 3.8999 3.90005 6.70988 3.90005 10.1762V17.4396C3.90005 20.9059 6.71004 23.7159 10.1763 23.7159H17.4398C20.9061 23.7159 23.716 20.9059 23.716 17.4396V10.1762C23.716 6.70988 20.9061 3.8999 17.4398 3.8999H10.1763ZM10.2283 5.55592C7.64784 5.55592 5.55597 7.64779 5.55597 10.2283V17.3346C5.55597 19.9151 7.64784 22.0069 10.2283 22.0069H17.3346C19.9151 22.0069 22.007 19.9151 22.007 17.3346V10.2283C22.007 7.6478 19.9151 5.55592 17.3346 5.55592H10.2283Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.8081 18.5374C16.4202 18.5374 18.5377 16.4199 18.5377 13.8078C18.5377 11.1958 16.4202 9.07825 13.8081 9.07825C11.196 9.07825 9.07849 11.1958 9.07849 13.8078C9.07849 16.4199 11.196 18.5374 13.8081 18.5374ZM13.8081 17.0875C15.6194 17.0875 17.0877 15.6191 17.0877 13.8078C17.0877 11.9965 15.6194 10.5282 13.8081 10.5282C11.9968 10.5282 10.5284 11.9965 10.5284 13.8078C10.5284 15.6191 11.9968 17.0875 13.8081 17.0875Z"
      fill="currentColor"
    />
    <circle cx="18.9865" cy="8.76779" r="1.13925" fill="currentColor" />
  </svg>
</template>

<script>
export default {
  name: "InstagramIcon"
};
</script>
